module.exports = __webpack_public_path__ + "img/diente4.c2179e78.svg";